const CLIENT_TYPE_OPTIONS = [
  { value: 'detalle', label: 'Detalle' },
  { value: 'mayorista', label: 'Mayorista' },
  { value: 'importador', label: 'Importador' },
];

const normalizeClientType = (value) => {
  if (value == null) return '';
  return String(value).trim().toLowerCase();
};

const resolvePriceClientType = (price) => {
  const normalized = normalizeClientType(price?.clientType);
  if (normalized) return normalized;
  return 'mayorista';
};

const getClientTypeLabel = (value) => {
  const normalized = normalizeClientType(value);
  const option = CLIENT_TYPE_OPTIONS.find((item) => item.value === normalized);
  return option ? option.label : normalized || 'Mayorista';
};

export {
  CLIENT_TYPE_OPTIONS,
  normalizeClientType,
  resolvePriceClientType,
  getClientTypeLabel,
};
